'use client';

import { Parallax } from 'react-scroll-parallax';
import Image from 'next/image';
import heroLeftClouds from '@/app/ui/images/hero_left.webp';
import heroRightClouds from '@/app/ui/images/hero_right.webp';
import roadmapLeftClouds from '@/app/ui/images/roadmap_left.webp';
import roadmapRightClouds from '@/app/ui/images/roadmap_right.webp';

export function HeroClouds() {
  return (
    <>
      <Parallax
        className="absolute bottom-[0px] left-0 h-full w-2/4"
        translateX={[0, -100]}
      >
        <Image
          src={heroLeftClouds}
          fill
          alt="Left side clouds"
          className="!inset-y-auto !bottom-0 !h-auto"
          sizes="50vw"
        />
      </Parallax>
      <Parallax
        className="absolute bottom-[0px] right-0 h-full w-2/4"
        translateX={[0, 100]}
      >
        <Image
          src={heroRightClouds}
          fill
          alt="Right side clouds"
          className="!inset-y-auto !bottom-0 !h-auto"
          sizes="50vw"
        />
      </Parallax>
    </>
  );
}

export function RoadmapClouds() {
  return (
    <>
      <Parallax
        className="absolute bottom-[0px] left-0 h-full w-2/4"
        translateX={[0, -100]}
      >
        <Image
          src={roadmapLeftClouds}
          fill
          alt="Left side clouds"
          className="!inset-y-auto !bottom-0 !h-auto"
          sizes="50vw"
        />
      </Parallax>
      <Parallax
        className="absolute bottom-[0px] right-0 h-full w-2/4"
        translateX={[0, 100]}
      >
        <Image
          src={roadmapRightClouds}
          fill
          alt="Right side clouds"
          className="!inset-y-auto !bottom-0 !h-auto"
          sizes="50vw"
        />
      </Parallax>
    </>
  );
}
